import * as PIXI from 'pixi.js';
import MediaPreprocessor from '../utils/MediaPreprocessor';
import BackgroundMedia from './BackgroundMedia';
export default class ImageMedia extends BackgroundMedia {
  constructor(model, app, image) {
    const scaledImage = MediaPreprocessor.scaleOutOfBoundsImage(app, image);
    const sprite = PIXI.Sprite.from(scaledImage);
    super(model, app, sprite);
  }

  seek() {
    return new Promise((resolve) => setTimeout(resolve));
  }
}
